export default "__VITE_ASSET__CgJzFKht__"